import { render, staticRenderFns } from "./LandingPageEdit.vue?vue&type=template&id=4ea839bf&scoped=true&"
import script from "./LandingPageEdit.vue?vue&type=script&lang=js&"
export * from "./LandingPageEdit.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageEdit.vue?vue&type=style&index=0&id=4ea839bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea839bf",
  null
  
)

export default component.exports